<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="550" content-class="rounded-lg" scrollable @keydown.esc="dialog = false">
			<v-card>
				<v-card-title class="h6">
					<span class="black--text text-uppercase font-weight-bold">Silahkan Pilih Akun</span>
					<v-spacer></v-spacer>
					<v-btn text small color="pink" class="mr-n4" @click="modalHide">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pb-0">
					<v-row align="center" justify="center">
						<v-col cols="12" v-if="account.length > 0">
							<v-list>
								<v-list-item-group
								v-model="selectedAccount"
								color="primary"
								>
								<v-list-item
								v-for="(item, i) in account"
								:key="i"
								:value="item"
								>
								<v-list-item-icon>
									<v-icon>mdi-account</v-icon>
								</v-list-item-icon>
								<v-list-item-content>
									<v-list-item-title> {{ item.user.user_name }} </v-list-item-title>
									<v-list-item-subtitle> {{item.user.user_username}} </v-list-item-subtitle>
								</v-list-item-content>
							</v-list-item>
						</v-list-item-group>
					</v-list>
				</v-col>
				<v-col cols="12" v-else>
					<div class="text-body-1 font-weight-bold pb-1">Jasa Kurir</div>
					<div class="text-center">Mohon maaf saat ini tidak ada kurir yang tersedia</div>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</v-dialog>
</v-row>
</template>

<script>

export default {
	data () {
		return {
			selectedAccount: {},
			dialog: false,
		}
	},
	props: {
		showPickupStore:{
			type: Boolean,
			default: false
		},
		account: {
			type: Array,
			default: () => []
		}
	},
	methods: {
		modalShow() {
			this.dialog = true
		},
		modalHide() {
			this.dialog = false
		},
		selectAccount(val) {
			this.$emit('action', val)
			this.modalHide()
		}
	},
	watch: {
		selectedAccount(val) {
			this.selectAccount(val)
		}
	}
};
</script>